import { Component, OnInit, Input, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate} from '@angular/animations';
import is from 'is_js';

import { RepositoryService } from './../../../shared/services/repository.service';
import { ErrorHandlerService } from './../../../shared/services/error-handler.service';

import { Router } from '@angular/router';
import { CONST } from './../../../shared/const';
import { Common } from './../../../shared/common';

import { Init } from './../../../_interfaces/init.model';
import { User } from './../../../_interfaces/user.model';
import { Company } from './../../../_interfaces/company.model';
import { Jan } from './../../../_interfaces/jan.model';
import { Value } from './../../../_interfaces/value.model';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(-100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
  ]
})
export class UserListComponent implements OnInit {

  // Input Data //////////////////////////////////////
  public users: User[] = [];
  public userId: String = '';

  // Master Data //////////////////////////////////////
  public categories: Value[] = [];
  public inchs: Value[] = [];
  public kubun1s: Value[] = [];
  public kubun2s: Value[] = [];
  public inventoryKubuns: Value[] = [];
  public riKubuns: Value[] = [];
  public bases: Value[] = [];
  public feceses: Value[] = [];
  public companies: Company[] = [];
  public jans: Jan[] = [];

  // Master Data //////////////////////////////////////
  public version: string = CONST.VERSION;
  public menuState: string = CONST.MENU.OUT;
  public errorTitle = '';
  public errorMessage = '';
  public isMobile: boolean = is.mobile();
  public isPad: boolean = is.ipad() || is.tablet();
  public isHorizontal: boolean = false;

  constructor(
    private repository: RepositoryService,
    private errorHandler: ErrorHandlerService,
    private router: Router
  ) { }

  ngOnInit() {
    if (Common.userId != '' || CONST.DEBUG) {
      this.getInit();
      this.isHorizontal = (window.orientation == 90);
    } else {
      this.router.navigate([CONST.VIEW.LOGIN]);
    }
  }
  
  @HostListener('window:orientationchange', ['$event'])
  onOrientationChange(event) {
    this.isHorizontal = (window.orientation == 90);
  }

  // View Action ////////////////////////////////////////////////////////////////
  public openMenu() {
    this.menuState = this.menuState === CONST.MENU.OUT ? CONST.MENU.IN : CONST.MENU.OUT;
  }

  public logout() {
    this.router.navigate([CONST.VIEW.LOGIN]);
  }

  public selectRow(event: any) {
    this.userId = event.selected[0].id;
  }

  public confirm() {
    this.errorTitle = '';
    this.errorMessage = '';
    if (this.userId == '') {
      this.errorTitle = CONST.MESSAGE.MODAL_TITLE.NONE_ROW;
      this.errorMessage = CONST.MESSAGE.MODAL_MESSAGE.NONE_ROW;
      $('#errorModal').modal();
      return;
    } else {
      $('#actionModal').modal();
    };
  }

  public changeAdmin() {
    this.postChengAdmin();
  }

  public userDelete() {
    this.postUserDelete();
  }

  public getRowClass(row) {
    return {'delete-color': row.isDeleted};
  }

  public cancel() {
  }

  public moveInputView(mode: string) {
    switch(mode) {
      case CONST.MODE.CREATE:
        this.userId = '';
      break;
      case CONST.MODE.EDIT:
        if (this.userId == '') {
          this.errorTitle = CONST.MESSAGE.MODAL_TITLE.NONE_ROW;
          this.errorMessage = CONST.MESSAGE.MODAL_MESSAGE.NONE_ROW;
          $('#errorModal').modal();
          return;
        }
      break;
    }
    this.router.navigate([CONST.VIEW.USER_MAINTENANCE, mode, this.userId]);
  }

  // Private Function ///////////////////////////////////////////////////////////

  // Web Api ////////////////////////////////////////////////////////////////////
  private getInit() {
    let apiAddress: string = CONST.API.INIT.GET_DATA;
    let res = this.repository.getData(apiAddress).subscribe(res => {
      let init = res as Init;
      this.categories = init.categories;
      this.inchs = init.inchs;
      this.kubun1s = init.kubun1s;
      this.kubun2s = init.kubun2s;
      this.inventoryKubuns = init.inventoryKubuns;
      this.riKubuns = init.riKubuns;
      this.bases = init.bases;
      this.feceses = init.feceses;
      this.companies = init.companies;
      this.jans = init.jans;
      this.getUserList();
    }, error => {
      this.errorHandler.handleError(error);
      this.errorMessage = this.errorHandler.errorMessage;
    });
  }

  private getUserList() {
    let apiAddress: string = CONST.API.USER.LIST;
    let res = this.repository.getData(apiAddress).subscribe(res => {
      let users = res as User[];
      this.users = users;
    }, error => {
      this.errorHandler.handleError(error);
      this.errorMessage = this.errorHandler.errorMessage;
    });
  }

  private postChengAdmin() {
    let apiAddress: string = CONST.API.USER.ADMIN;
    this.repository.post(apiAddress, {id: this.userId}).subscribe(res => {
      this.getUserList();
      this.userId = '';
    }, error => {
      this.errorHandler.handleError(error);
    });
  }

  private postUserDelete() {
    let apiAddress: string = CONST.API.USER.DELETE;
    this.repository.post(apiAddress, {id: this.userId}).subscribe(res => {
      this.getUserList();
      this.userId = '';
    }, error => {
      this.errorHandler.handleError(error);
    });
  }
}
